import { render, staticRenderFns } from "./McmChip.vue?vue&type=template&id=3bc600e9&scoped=true&"
var script = {}
import style0 from "./McmChip.vue?vue&type=style&index=0&id=3bc600e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc600e9",
  null
  
)

export default component.exports